import { fetchCouriers } from 'fetch/fetchCouriers';
import { ChangeEvent, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { CourierJson } from 'types/bundleTypes';

export const usePreferredAreaData = () => {
  const [courierList, setCourierList] = useState<CourierJson[]>([]);
  const [selectedCourier, setSelectedCourier] = useState<CourierJson>();

  const [isFetchingCourierList, setIsFetchingCourierList] = useState(true);
  const [isFetchingSelectedCourier, setIsFetchingSelectedCourier] =
    useState(true);

  const params = useParams<{ courierId?: string }>();

  const history = useHistory();

  useEffect(() => {
    const fetchCourierList = async () => {
      const newCourierList = await fetchCouriers();
      setCourierList(newCourierList);
      setIsFetchingCourierList(false);
    };

    setIsFetchingCourierList(true);
    fetchCourierList().catch();
  }, []);

  /* Default value of SelectedCourier and their Preferences */
  useEffect(() => {
    setIsFetchingSelectedCourier(true);

    /* Do nothing when the Courier's ID from URL is not defined */
    if (!params.courierId) {
      setIsFetchingSelectedCourier(false);
      return;
    }

    /* Update the SelectedCourier data */
    const selectedCourierId = selectedCourier?.id;
    const courierIdFromURL = parseInt(params.courierId);
    if (selectedCourierId !== courierIdFromURL) {
      const newSelectedCourier = courierList.find(
        courier => courier.id === courierIdFromURL
      );
      setSelectedCourier(newSelectedCourier);
    }
    setIsFetchingSelectedCourier(false);
  }, [courierList, params.courierId, selectedCourier?.id]);

  const onChangeSelectedCourier = (
    _: ChangeEvent<any>,
    value: string | CourierJson
  ) => {
    setIsFetchingSelectedCourier(true);

    if (typeof value === 'string') {
      /* do nothing */
      return;
    }

    if ((value as CourierJson)?.id) {
      history.push(`/planner/preferred-areas/${(value as CourierJson)?.id}`);
    } else {
      history.push(`/planner/preferred-areas`);
    }
  };

  return {
    isFetchingCourierList,
    isFetchingSelectedCourier,
    courierList,
    selectedCourier,
    onChangeSelectedCourier,
  };
};
